import { render, staticRenderFns } from "./SubscriptionPayment.vue?vue&type=template&id=06b4e8d6&scoped=true"
import script from "./SubscriptionPayment.vue?vue&type=script&lang=js"
export * from "./SubscriptionPayment.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionPayment.vue?vue&type=style&index=0&id=06b4e8d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b4e8d6",
  null
  
)

export default component.exports